<template>
  <div class="GlobalTable">
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="this.seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="回复" slot="questionAnswer" align="center">
        <template slot-scope="{ row }">
          <el-tooltip
            v-if="row.questionAnswer"
            class="item"
            effect="dark"
            :content="row.questionAnswer"
            placement="top"
          >
            <div class="Remarks">
              {{ row.questionAnswer }}
            </div>
          </el-tooltip>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="排序" slot="stor" align="center">
        <template slot-scope="{ row }">
          <el-input-number
            size="small"
            v-model="row.sort"
            @change="handleChangeNum(row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <!-- slot-scope="{ row }" -->
          <el-button size="mini" type="primary" round @click="problemClick(row)"
            >编辑</el-button
          >
          <el-button
            v-if="!row.isDivide"
            size="mini"
            type="danger"
            round
            @click="delClick(row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>

    <!-- 编辑 -->
    <el-dialog
      title="编辑问题"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @closed="dialogVisible = false"
    >
      <el-form
        :model="formDataDialog"
        :rules="formRulesDialog"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="问题类型" prop="questionTypeId">
          <el-select v-model="formDataDialog.questionTypeId" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in option"
              :key="item.questionTypeId"
              :label="item.questionTypeName"
              :value="item.questionTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题名称" prop="questionName">
          <el-input
            v-model="formDataDialog.questionName"
            placeholder="请输入问题名称（20字内）"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题回复" prop="questionAnswer">
          <el-input
            type="textarea"
            maxlength="200"
            v-model="formDataDialog.questionAnswer"
            :autosize="{ minRows: 7, maxRows: 7 }"
            show-word-limit
            placeholder="请输入问题回复"
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleConfirmDialog('ruleForm')"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog
      title="提示"
      :visible.sync="delDialogVisible"
      :close-on-click-modal="false"
      width="400px"
      @closed="delClosed"
    >
      <div class="mb-20">确认要删除该条数据吗？</div>
      <!-- <el-input
        v-model="formData.remark"
        placeholder="请输入谷歌动态验证码"
      ></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="delDialogVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="delConfirmDialog"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "Table",
  props: {
    option: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
      loading: false,
      seachDataList: [],
      delDialogVisible: false,
      dialogVisible: false,
      formDataDialog: {
        questionAnswer: "",
        questionName: "",
        questionTypeId: "",
        id: "",
      },
      formRulesDialog: {
        questionTypeId: [
          {
            required: true,
            trigger: "blur",
            message: "请选择问题类型",
          },
        ],
        questionName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入问题名称",
          },
        ],
        questionAnswer: [
          {
            required: true,
            trigger: "blur",
            message: "请输入问题回复",
          },
        ],
      },
      formData: {
        commentId: "",
        content: "",
        images: [],
        price: "",
        recycleType: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableColumns: [
        { label: "问题类型", prop: "questionTypeName" },
        { label: "问题", prop: "questionName" },
        // { label: "回复", prop: "questionAnswer" },
        { slotName: "questionAnswer" },
        { label: "最近更新时间", prop: "updateTime" },
        { label: "最近更新人员", prop: "adminAcc" },
        { slotName: "stor" },
        { slotName: "operation" },
      ],
      commentId: "",
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        questionTypeId: this.SeachParams.questionTypeId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api.questionList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.loading = false;
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 编辑问题弹窗
    problemClick(row) {
      this.formDataDialog.id = row.id;
      this.formDataDialog.questionAnswer = row.questionAnswer;
      this.formDataDialog.questionName = row.questionName;
      this.formDataDialog.questionTypeId = row.questionTypeId;
      this.dialogVisible = true;
    },
    // 编辑问题弹框关闭
    problemClosed() {
      this.dialogVisible = false;
    },
    handleUploadGroupChange(list) {
      this.formData.images = list;
    },
    handleConfirmDialog(formName) {
      console.log(this.formDataDialog);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _api
            .questionSaveOrUpdate(this.formDataDialog)
            .then((res) => {
              if (res.code === 1) {
                this.handleCurrentChange();
                this.dialogVisible = false;
                this.$message.success(res.msg);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        } else {
          return false;
        }
      });
    },
    // 排序
    handleChangeNum(row) {
      const params = {
        id: row.id,
        sort: row.sort,
      };
      _api.updateSort(params).then((res) => {
        if (res.code === 1) {
          this.handleCurrentChange();
          this.$message.success(res.msg);
        }
      });
    },
    // 删除
    delClick(id) {
      this.delDialogVisible = true;
      this.commentId = id;
    },
    delClosed() {
      this.delDialogVisible = false;
    },
    delConfirmDialog() {
      _api.questionDelete({ id: this.commentId }).then((res) => {
        if (this.seachDataList.length == 1 && this.page.pageNum > 1) {
          this.page.pageNum = this.page.pageNum - 1;
        }
        this.delDialogVisible = false;
        this.handleCurrentChange();
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .mb-10 {
    margin-bottom: 10px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mr-50 {
    margin-right: 50px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .font-w {
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb {
    display: flex;
    justify-content: space-between;
  }
  .flex-as {
    display: flex;
    align-items: flex-start;
  }
  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
  .images-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .images-box > img {
    width: 70px;
    height: 70px;
    margin-bottom: 10px;
  }
  .images-box > span {
    color: #0981ff;
    cursor: pointer;
  }
  .text-down {
    color: #0981ff;
    cursor: pointer;
    text-decoration: underline;
  }
}
.Remarks {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //控制行数
  overflow: hidden;
}
</style>
